<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="商会活动名称">
          <el-input placeholder="请输入商会活动名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加商会活动</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="商会活动名称"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusTagType(scope.row.status)" size="small">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="auditClick(scope.row)" type="text" size="small" v-if="scope.row.status ==0">审核</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加组件 -->
    <Add :open_add="open_add" :supply_id="supply_id" v-if="open_add" @close="closeAdd"></Add>

    <!-- 编辑组件 -->
    <Edit :open_add="open_edit" :supply_activity_id="supply_activity_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 审核弹窗 -->
    <el-dialog
      title="审核商会活动"
      :visible.sync="auditDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      @close="closeAuditDialog"
    >
      <el-form :model="auditForm" label-width="80px" ref="auditForm">
        <el-form-item label="活动名称">
          <el-input v-model="auditForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="审核状态" prop="status" required>
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="审核意见" prop="audit_remark">
          <el-input
            type="textarea"
            v-model="auditForm.audit_remark"
            placeholder="请输入审核意见"
            :rows="4"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAuditDialog">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    ></el-dialog>
  </div>
</template>

<script>
import Supply_activityApi from "@/api/supply_activity.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit,
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
      },

      open_add: false,
      open_edit: false,
      supply_id: this.$route.query.supply_id,
      supply_activity_id: "",
      dialogVisible: false,

      // 审核相关数据
      auditDialogVisible: false,
      auditLoading: false,
      auditForm: {
        supply_activity_id: "",
        name: "",
        status: 1, // 1:通过, 2:拒绝
        audit_remark: "",
      },
    };
  },
  created() {
    console.log("supply_id", this.supply_id);
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //商会活动标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.supply_id = self.supply_id;
      self.loading = true;
      Supply_activityApi.list(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.supply_activity_id = row.supply_activity_id;
      this.open_edit = true;
    },

    /*审核活动*/
    auditClick(row) {
      this.auditForm = {
        supply_activity_id: row.supply_activity_id,
        name: row.name,
        status: 1, // 默认通过
        audit_remark: "",
      };
      this.auditDialogVisible = true;
    },

    /*关闭审核弹窗*/
    closeAuditDialog() {
      this.auditDialogVisible = false;
      this.$refs.auditForm.resetFields();
    },

    /*提交审核*/
    submitAudit() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          this.auditLoading = true;
          Supply_activityApi.audit(this.auditForm, true)
            .then((data) => {
              this.auditLoading = false;
              if (data.code == 1) {
                this.$message({
                  message: "审核成功",
                  type: "success",
                });
                this.auditDialogVisible = false;
                this.getTableList();
              } else {
                this.$message.error(data.msg || "审核失败");
              }
            })
            .catch((error) => {
              this.auditLoading = false;
              this.$message.error("审核失败，请重试");
            });
        }
      });
    },

    /*获取状态标签类型*/
    getStatusTagType(status) {
      const statusMap = {
        0: "info", // 待审核
        1: "success", // 审核通过
        2: "danger", // 审核拒绝
      };
      return statusMap[status] || "info";
    },

    /*获取状态文本*/
    getStatusText(status) {
      const statusTextMap = {
        0: "待审核",
        1: "已通过",
        2: "已拒绝",
      };
      return statusTextMap[status] || "未知状态";
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          Supply_activityApi.del(
            {
              supply_activity_id: row.supply_activity_id,
            },
            true
          )
            .then((data) => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch((error) => {});
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
/* 可以添加一些自定义样式 */
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/enterprise/activity/index.vue